import { render, staticRenderFns } from "./viewRes.vue?vue&type=template&id=3bad4bd6&scoped=true&"
import script from "./viewRes.vue?vue&type=script&lang=js&"
export * from "./viewRes.vue?vue&type=script&lang=js&"
import style0 from "./viewRes.vue?vue&type=style&index=0&id=3bad4bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad4bd6",
  null
  
)

export default component.exports